import { string, arrayOf } from 'prop-types';
import React from 'react';

const PrintGraphicsImageContainer = ({ mainImage, images = [] }) => {
	const defaultImage = `${process.env.PUBLIC_URL}/images/trend/demo-dress.png`;
	const filledImages = [...images, ...Array(3 - images.length).fill(defaultImage)].slice(0, 3);

	return (
		<div className="trend-product-img-container-top">
			<div className="prev-img-thum">
				<img src={mainImage || defaultImage} alt="Top Image" className="top-image" />
			</div>
			<div className="bottom-grid">
				{filledImages.map((img, index) => (
					<img key={index} src={img} alt="Image 1" />
				))}
			</div>
		</div>
	);
};

PrintGraphicsImageContainer.propTypes = {
	mainImage: string.isRequired,
	images: arrayOf(string).isRequired
};

export default PrintGraphicsImageContainer;
